import { render, staticRenderFns } from "./EditWelHihotel.vue?vue&type=template&id=daf155d2&scoped=true"
import script from "./EditWelHihotel.vue?vue&type=script&lang=js"
export * from "./EditWelHihotel.vue?vue&type=script&lang=js"
import style0 from "./EditWelHihotel.vue?vue&type=style&index=0&id=daf155d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf155d2",
  null
  
)

export default component.exports